<template>
    <or-button
        class="train-btn"
        type="primary"
        color="primary"
        icon="cloud_upload"
        size="small"
        :disabled="isPublishButtonDisabled"
        :loading="isVersionPublishing"
        @click="trainVersion"
    >
      {{ $t('model.nlu-model.header.publishbutton.publish') }}
    </or-button>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState('knowledgebase/versions', ['isVersionPublishing']),
    ...mapGetters('knowledgebase/versions', ['isPublishButtonDisabled'])
  },

  methods: {
    ...mapActions('knowledgebase/versions', ['trainVersion'])
  }
}
</script>
